
export default function WhyChooseSection() {
  const reasons = [
    {
      icon: 'ri-award-line',
      title: 'QCTO Accredited',
      description: 'All our programmes are nationally recognised and QCTO accredited for quality assurance.'
    },
    {
      icon: 'ri-team-line',
      title: 'Expert Facilitators',
      description: 'Industry professionals with 15+ years of experience in training and development.'
    },
    {
      icon: 'ri-settings-line',
      title: 'Customised Solutions',
      description: 'Tailored training programmes designed specifically for your business needs and objectives.'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Flexible Delivery',
      description: 'On-site, virtual, or blended learning options to accommodate your schedule and preferences.'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Measurable Results',
      description: 'Comprehensive assessment and reporting to track training effectiveness and ROI.'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Ongoing Support',
      description: 'Dedicated account management and post-training support to ensure lasting impact.'
    }
  ];

  return (
    <section className="section-wrap bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-heading">
            Why Corporate Clients Choose Us
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Trusted by leading organisations across South Africa for our commitment to excellence and results
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div key={index} className="text-center p-6">
              <div className="w-16 h-16 bg-[#2D7F3E] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${reason.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {reason.title}
              </h3>
              <p className="text-gray-600">
                {reason.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="bg-gray-50 rounded-xl p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Ready to Transform Your Team?
            </h3>
            <p className="text-gray-600 mb-6">
              Join over 500+ companies that have improved their performance with our training solutions
            </p>
            <button className="btn btn-primary">
              Schedule a Consultation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
